export function getBinRoutes() {
  return [
    {
      path: "/bin",
      name: "bin",
      component: () => import(/* webpackChunkName: "bin-list" */ "./views/BinList.vue"),
    },
  ]
}
